import React from "react";
import { Link } from "react-router-dom";

/**
 * Visible breadcrumbs. The matching BreadcrumbList JSON-LD is emitted by each
 * page — Google wants the markup to describe a trail the user can actually see.
 */
const Breadcrumbs = ({ trail }) => (
  <nav className="breadcrumbs" aria-label="Breadcrumb">
    <ol>
      {trail.map((crumb, idx) => {
        const isLast = idx === trail.length - 1;
        return (
          <li key={crumb.path}>
            {isLast ? (
              <span aria-current="page">{crumb.name}</span>
            ) : (
              <Link to={crumb.path}>{crumb.name}</Link>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumbs;
